import React from 'react'

function News() {
  return (
    <div>section is under construction</div>
  )
}

export default News